import { ReactNode } from 'react';

import './FormActionbar.scss';

export type FormActionbarProps = {
    children: ReactNode;
};

export const FormActionbar = ({ children }: FormActionbarProps) => <div className="form-actionbar">{children}</div>;
